const schema = {
  'type': 'object',
  'required': [],
  'properties': {
    'facilitySettings': {
      'required': [],
      'type': ['object'],
      'title': '機構設定',
      'properties': {
        'dba': {
          'type': ['string', 'null'],
          'title': '別名/登記名稱',
        },
        'govQualifiedPrice': {
          'type': ['number', 'null'],
          'title': '政府核定單價',
        },
        'lunchStartTime': {
          'type': ['string', 'null'],
          'title': '午餐服務開始時間',
          'format': 'time',
          'default': '10:00',
          'description': '套用於衛福部支審系統報表',
        },
        'lunchEndTime': {
          'type': ['string', 'null'],
          'title': '午餐服務結束時間',
          'format': 'time',
          'default': '12:00',
          'description': '套用於衛福部支審系統報表',
        },
        'dinnerStartTime': {
          'type': ['string', 'null'],
          'title': '晚餐服務開始時間',
          'format': 'time',
          'default': '16:00',
          'description': '套用於衛福部支審系統報表',
        },
        'dinnerEndTime': {
          'type': ['string', 'null'],
          'title': '晚餐服務結束時間',
          'format': 'time',
          'default': '18:00',
          'description': '套用於衛福部支審系統報表',
        },
        'deliverySetting': {
          'required': [],
          'type': ['object', 'null'],
          'title': '送餐設定',
          'properties': {
            'canStartDeliveryBefore': {
              'type': ['number', 'null'],
              'title': '提早送餐',
              'default': 2.5,
              'description': '送餐大使可以提早幾個小時開始送餐',
            },
            'canStartDeliveryAfter': {
              'type': ['number', 'null'],
              'title': '延後送餐',
              'default': 2.5,
              'description': '送餐大使可以延後幾個小時開始送餐',
            },
            'canCompleteOrderAfter': {
              'type': ['number', 'null'],
              'title': '完成日誌',
              'default': 24,
              'description': '送餐大使送達餐點後幾個小時內可以完成日誌',
            },
            'canModifyDiaryAfter': {
              'type': ['number', 'null'],
              'title': '修改日誌',
              'default': 9,
              'description': '送餐大使完成日誌後幾個小時內可以修改日誌',
            },
          },
        },
        'receiptInfo': {
          'required': [],
          'type': ['object', 'null'],
          'title': '收據資訊',
          'properties': {
            'receiptType': {
              'type': ['string', 'null'],
              'title': `收據格式`,
              'enum': ['duplicate', 'triplicate'],
              'enumNames': ['一式二聯', '一式三聯'],
              'default': 'triplicate',
            },
            'taxIdNumber': {
              'type': ['string', 'null'],
              'title': `統一編號`,
              'default': '',
            },
            'faxNumber': {
              'type': ['string', 'null'],
              'title': `傳真`,
              'default': '',
            },
            'bankName': {
              'type': ['string', 'null'],
              'title': `銀行名稱1`,
              'default': '',
            },
            'accountNumber': {
              'type': ['string', 'null'],
              'title': `匯款帳號1`,
              'default': '',
            },
            'accountName': {
              'type': ['string', 'null'],
              'title': `帳戶名1`,
              'default': '',
            },
            'bankName2': {
              'type': ['string', 'null'],
              'title': `銀行名稱2`,
              'default': '',
            },
            'accountNumber2': {
              'type': ['string', 'null'],
              'title': `匯款帳號2`,
              'default': '',
            },
            'accountName2': {
              'type': ['string', 'null'],
              'title': `帳戶名2`,
              'default': '',
            },
            'bankName3': {
              'type': ['string', 'null'],
              'title': `銀行名稱3`,
              'default': '',
            },
            'accountNumber3': {
              'type': ['string', 'null'],
              'title': `匯款帳號3`,
              'default': '',
            },
            'accountName3': {
              'type': ['string', 'null'],
              'title': `帳戶名3`,
              'default': '',
            },
            'chairmanName': {
              'type': ['string', 'null'],
              'title': `主管姓名`,
              'default': '',
              'description': '若有收據主管章，則不顯示主管姓名',
            },
            'accountantName': {
              'type': ['string', 'null'],
              'title': `會計姓名`,
              'default': '',
              'description': '若有收據會計章，則不顯示會計姓名',
            },
            'handlerName': {
              'type': ['string', 'null'],
              'title': `經手人姓名`,
              'default': '',
              'description': '若有收據經手人章，則不顯示經手人姓名',
            },
            'managerTitle': {
              'type': ['string', 'null'],
              'title': `主管職稱`,
              'default': '',
              'description': '收據上用印主管職稱',
            },
            'reverseCopyType': {
              'type': ['boolean', 'null'],
              'title': '第一聯為個案收執聯',
              'default': false,
            },
            'oneCopyOneSheet': {
              'type': ['boolean', 'null'],
              'title': '列印時一聯印一張',
              'default': false,
            },
            'note': {
              'type': ['string', 'null'],
              'title': `備註`,
              'default': '',
            },
          },
        },
        'receiptSettings': {
          'required': [],
          'type': ['object', 'null'],
          'title': '收據費用設定(弱勢長輩)',
          'properties': {
            'originalPrice': {
              'type': ['number', 'null'],
              'title': '原價',
            },
            'copaymentSettings': {
              'type': ['array', 'null'],
              'title': '部分負擔設定',
              'description': '',
              'items': {
                'required': [
                  'disadvantagedType',
                  'disadvantagedLabel',
                  'copayment',
                ],
                'type': 'object',
                'properties': {
                  'disadvantagedType': {
                    'type': 'string',
                    'title': '福利身份別設定',
                    'description': '需同送餐對象的弱勢身份別設定，例如：低收',
                  },
                  'disadvantagedLabel': {
                    'type': 'string',
                    'title': '福利身份別描述',
                    'description': '顯示於收據的福利身份別欄位，例如：低收（全額補助100%）',
                  },
                  'copayment': {
                    'type': 'number',
                    'title': '部分負擔',
                    'default': 0,
                  },
                },
              },
              'default': [],
            },
          },
        },
      },
    },
  },
};

export default schema;
